/* ============================================================================
   Registers the "Proofs" request-detail tab. Self-contained — no edits to the
   Requests module or the tab registry itself.
   ============================================================================ */

import { registerRequestTab } from '../../app/requestTabs';
import ProofingTab from './ProofingTab';

registerRequestTab({
  id: 'proofing',
  label: 'Proofs',
  order: 20,
  roles: ['Requester', 'Designer', 'Admin', 'SystemAdmin'],
  component: ProofingTab,
});
